import {translations} from 'presentation/translations-new';
import * as z from 'zod';

const {requiredField} = translations['pt-br'].commons;
const {protocolHelperText, protocolHelperTextWithProtocol} =
	translations['pt-br'].privateFlow.refund.additionalDocuments.searchProtocol;

const requestMessage = (isViewSupplementaryDocumentsEnabled: boolean) =>
	isViewSupplementaryDocumentsEnabled ? protocolHelperTextWithProtocol : requiredField;

const regexMessage = (isViewSupplementaryDocumentsEnabled: boolean) =>
	isViewSupplementaryDocumentsEnabled ? protocolHelperTextWithProtocol : protocolHelperText;

export function getFormSchema(isViewSupplementaryDocumentsEnabled: boolean) {
	return z.object({
		request: z
			.string({
				required_error: requestMessage(isViewSupplementaryDocumentsEnabled),
			})
			.min(1, requestMessage(isViewSupplementaryDocumentsEnabled))
			.regex(/^\d{12}$/, regexMessage(isViewSupplementaryDocumentsEnabled)),

		description: z.string(),
	});
}

export type FormSchemaValues = z.infer<ReturnType<typeof getFormSchema>>;
